import { useEffect, useState, useRef } from "react";
import { Row, Form, Col, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import {
  InputControl,
  InputValidationConstants,
  SubmitButtonContent,
  TextAreaControl,
  SelectControl,
  TinymceControl,
  createOptionsFromEnum,
  Modal,
  Loading,
  NumberControl,
  CheckboxControl,
  DateTimeControl,
} from "wup-module1-base";
import { RoutePathConstants, QuestionTypeEnum } from "../../../../Constants";
/**
 * Komponent strony dodawania parametru raportu
 */
function QuestionModal({
  isEdit = null,
  question = null,
  setQuestion,
  appendQuestion,
  updateQuestion,
  questionFields,
}) {
  const {
    register,
    getValues,
    setValue,
    reset,
    trigger,
    watch,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [content, setContent] = useState(question?.content2 ?? "");
  const answerType = watch("answer.type");
  const answerMin = watch("answer.minValue");
  const answerMax = watch("answer.maxValue");

  useEffect(() => {
    if (!!question) {
      // console.log(question);
      // if (reset) reset(question).then(() => trigger());
      reset(question);
      setTimeout(trigger, 0);
      // console.log(getValues());
    }

    // console.log(question);
    //if (!!question && !question?.content2) handleContentChange("");
    // if (reset) {
    //   reset(question);
    //   setTimeout(trigger, 10);
    //   if (!!question && !question?.content2) handleContentChange("");
    //   // if (!!question && !!question?.content2)
    //   //   handleContentChange(question.content2);
    // }
    //console.log(question);
  }, [question, reset]);

  useEffect(() => {
    setTimeout(trigger, 10);
  }, [answerType, answerMin, answerMax, content]);

  // useEffect(() => {
  //   console.log(question);
  // }, [question]);

  const handleContentChange = (html) => {
    setContent(html);
    setValue("content2", html);
  };

  const onSubmit = () => {
    const data = getValues();
    const tinyContent = data.content2;
    delete data.content2;
    const toSubmit = {
      ...data,
      content: tinyContent,
      order: question.order,
      id: question.id,
    };
    setIsSubmitting(true);
    if (!isEdit) appendQuestion(toSubmit);
    else {
      const foundQuestion = questionFields.find((i) => i.id === question.id);
      const questionIdx = questionFields.indexOf(foundQuestion);
      updateQuestion(questionIdx, toSubmit);
    }
    setIsSubmitting(false);
    setQuestion(null);
  };

  return (
    <Modal
      show={!!question}
      size={"xl"}
      title={`${isEdit ? "Edycja" : "Dodawanie"} pytania skorelowanego`}
      onConfirm={onSubmit}
      onCancel={() => setQuestion(null)}
      confirmButtonText={
        isSubmitting ? (
          <Loading size="sm" className="px-2" variant="light" />
        ) : isEdit ? (
          "Zapisz"
        ) : (
          "Dodaj"
        )
      }
      confirmButtonDisabled={isSubmitting}
      enforceFocus={false}
    >
      <Form>
        <Row>
          <Col md={6}>
            <InputControl
              id={"name"}
              label={"Nazwa"}
              readOnly={false}
              refs={{
                ...register("name", {
                  required: InputValidationConstants.required,
                  maxLength: {
                    value: 100,
                    message: InputValidationConstants.maxLength.replace(
                      "{placeholder}",
                      100
                    ),
                  },
                }),
              }}
              errors={errors}
            />
          </Col>
          <Col md={6}>
            <SelectControl
              id={"type"}
              label={"Typ"}
              readOnly={false}
              options={createOptionsFromEnum(QuestionTypeEnum, false)}
              refs={{
                ...register("type", {
                  required: InputValidationConstants.required,
                }),
              }}
              errors={errors}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <TextAreaControl
              id={"description"}
              label={"Opis"}
              readOnly={false}
              rows={4}
              refs={{
                ...register("description", {
                  //required: InputValidationConstants.required,
                  maxLength: {
                    value: 512,
                    message: InputValidationConstants.maxLength.replace(
                      "{placeholder}",
                      512
                    ),
                  },
                }),
              }}
              errors={errors}
            />
          </Col>
        </Row>
        {!!question && (
          <Row>
            <Col md={12} sm={12}>
              <TinymceControl
                id="content2"
                label="Treść"
                htmlContent={content}
                rows={3}
                onChange={handleContentChange}
              />
            </Col>
          </Row>
        )}

        <Row>
          <Col md={3}>
            <SelectControl
              id={"answer.type"}
              label={"Typ odpowiedzi"}
              readOnly={false}
              options={createOptionsFromEnum(QuestionTypeEnum, false)}
              refs={{
                ...register("answer.type", {
                  required: InputValidationConstants.required,
                }),
              }}
              errors={errors}
            />
          </Col>
          {answerType && answerType == QuestionTypeEnum.Date.value && (
            <>
              <Col md={3}>
                <DateTimeControl
                  id={"answer.minValue"}
                  label={"Data od"}
                  required={true}
                  type="date"
                  max={getValues("answer.maxValue")}
                  refs={{
                    ...register("answer.minValue", {}),
                  }}
                  errors={errors}
                />
              </Col>
              <Col md={3}>
                <DateTimeControl
                  id={"answer.maxValue"}
                  label={"Data do"}
                  required={true}
                  type="date"
                  min={getValues("answer.minValue")}
                  refs={{
                    ...register("answer.maxValue", {
                      min: {
                        value: getValues("answer.minValue"),
                        message: 'Data nie może być wcześniejsza niż "Data od"',
                      },
                    }),
                  }}
                  errors={errors}
                />
              </Col>
            </>
          )}
          {answerType && answerType == QuestionTypeEnum.Number.value && (
            <>
              <Col md={3}>
                <NumberControl
                  id={"answer.minValue"}
                  label={"Liczba od"}
                  max={getValues("answer.maxValue")}
                  refs={{
                    ...register("answer.minValue", {}),
                  }}
                  errors={errors}
                />
              </Col>
              <Col md={3}>
                <NumberControl
                  id={"answer.maxValue"}
                  label={"Liczba do"}
                  min={getValues("answer.minValue")}
                  refs={{
                    ...register("answer.maxValue", {
                      min: {
                        value: getValues("answer.minValue"),
                        message: 'Liczba nie może być mniejsza niż "Liczba od"',
                      },
                    }),
                  }}
                  errors={errors}
                />
              </Col>
            </>
          )}
          {answerType && answerType == QuestionTypeEnum.Text.value && (
            <>
              <Col md={3}>
                <NumberControl
                  id={"answer.minValue"}
                  label={"Minimalna długość"}
                  min={1}
                  max={getValues("answer.maxValue")}
                  refs={{
                    ...register("answer.minValue", {}),
                  }}
                  errors={errors}
                />
              </Col>
              <Col md={3}>
                <NumberControl
                  id={"answer.maxValue"}
                  label={"Maksymalna długość"}
                  min={getValues("answer.minValue")}
                  refs={{
                    ...register("answer.maxValue", {
                      min: {
                        value: getValues("answer.minValue"),
                        message: "Liczba nie może być mniejsza niż min. dł.",
                      },
                    }),
                  }}
                  errors={errors}
                />
              </Col>
              <Col md={3}>
                <NumberControl
                  id={"answer.rowNr"}
                  label={"Ilość wierszy"}
                  min={1}
                  refs={{
                    ...register("answer.rowNr", {}),
                  }}
                  errors={errors}
                />
              </Col>
            </>
          )}
          {answerType && answerType == QuestionTypeEnum.OptionList.value && (
            <>
              <Col md={3}>
                <NumberControl
                  id={"answer.maxValue"}
                  label={"Maksymalna liczba zaznaczonych"}
                  min={getValues("answer.minValue")}
                  refs={{
                    ...register("answer.maxValue", {}),
                  }}
                  errors={errors}
                />
              </Col>
              <Col md={3}>
                <NumberControl
                  id={"answer.rowNr"}
                  label={"Ilość wierszy"}
                  min={1}
                  refs={{
                    ...register("answer.rowNr", {}),
                  }}
                  errors={errors}
                />
              </Col>
            </>
          )}
        </Row>
        <CheckboxControl
          id={"answer.isRequired"}
          label={"Czy odpowiedź jest wymagana ?"}
          refs={{
            ...register("answer.isRequired"),
          }}
          errors={errors}
        />
      </Form>
    </Modal>
  );
}

export default QuestionModal;
